import axios from 'axios';

import { setUserToNotAuthorized } from '../store/actions/userAction';
import store from '../store/store';

const token = localStorage.getItem('token');
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    Accept: 'application/json',
    Authorization: token ? `Bearer ${token}` : 'Bearer ',
  },
});

axiosInstance.defaults.withCredentials = true;

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    const normalizedError = error?.response
      ? error
      : {
          ...error,
          response: {
            data: {
              message: 'Please check your internet connection and try again.',
            },
          },
        };

    if (normalizedError?.response?.status === 401) {
      store.dispatch(setUserToNotAuthorized());
      window.location.reload();
    }

    return Promise.reject(normalizedError);
  },
);

export default axiosInstance;
